import {connect} from 'react-redux';

import {DraftMessageModel} from '../../../../../libs/shared/core/src/models/api/messageModel';
import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../../store/appState';
import {makeGetDraftChannel} from '../../../../store/data/messages/messagesSelectors';
import {getIsUserVisitor} from '../../../../store/data/teammates/teammatesSelectors';
import {ComposerChannelPicker} from './composerChannelPicker';
import {ChannelSaver} from './pickChannelDropdownContainer';

/*
 * Props.
 */

interface ComposerChannelPickerContainerProps {
  message: DraftMessageModel;
  saveChannel: ChannelSaver;
}

/*
 * Selectors.
 */

function getMessage(_state: AppState, props: ComposerChannelPickerContainerProps) {
  return props.message;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ComposerChannelPickerContainerProps>()(() => ({
  isUserVisitor: getIsUserVisitor,
  channel: makeGetDraftChannel(getMessage),
}));

export const ComposerChannelPickerContainer = connect(mapStateToProps)(ComposerChannelPicker);
